'use client';

import { Listbox, ListboxButton, ListboxOption, ListboxOptions, Transition } from '@headlessui/react';
import { classNames } from 'helpers/classNames';
import { memo } from 'react';

interface DatePickerMonthSelectProps {
  value: string;
  onChange: (month: string) => void;
}

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

function DatePickerMonthSelect({ value, onChange }: DatePickerMonthSelectProps) {
  return (
    <Listbox value={value} onChange={onChange}>
      {({ open }) => (
        <>
          <div className='relative w-24'>
            <ListboxButton className=' bg-white/20 relative w-full cursor-pointer rounded-md border border-gray-300  text-white py-2 px-3 text-left shadow-sm focus:border-gray-50 focus:ring-1 focus:ring-gray-50'>
              <span className='block truncate font-semibold text-center'>{value}</span>
            </ListboxButton>

            <Transition
              show={open}
              leave='transition ease-in duration-100'
              leaveFrom='opacity-100'
              leaveTo='opacity-0'>
              <ListboxOptions className=' absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm'>
                {months.map((month) => (
                  <ListboxOption
                    key={month}
                    className={({ active }) =>
                      classNames(
                        active ? 'text-white bg-teal-800' : 'text-gray-900',
                        'relative cursor-default select-none py-2'
                      )
                    }
                    value={month}>
                    {({ selected, active }) => (
                      <>
                        <span
                          className={classNames(
                            selected ? 'font-semibold' : 'font-normal',
                            'block truncate'
                          )}>
                          {month}
                        </span>
                      </>
                    )}
                  </ListboxOption>
                ))}
              </ListboxOptions>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  );
}

DatePickerMonthSelect.displayName = 'DatePickerMonthSelect';

export default memo(DatePickerMonthSelect);
